import { render, staticRenderFns } from "./PreviewPreScreening.vue?vue&type=template&id=12f03869"
import script from "./PreviewPreScreening.vue?vue&type=script&lang=js"
export * from "./PreviewPreScreening.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports